<template>
    <x-page :title="pageTitle">
        <template #header-actions>
            <x-back-button :disabled="isLoading" />
        </template>

        <translation-draft-form
            id="translation-draft-form"
            @submit="handleSubmit"
            :disabled="isLoading"
            :errors="errors"
            :initialFields="initialFields"
        />

        <template #footer>
            <x-submit-button
                form="translation-draft-form"
                :is-loading="isLoading"
                :disabled="isLoading"
            />
        </template>
    </x-page>
</template>

<script>
import XBackButton from "../../components/XBackButton.vue";
import XPage from "../../components/XPage.vue";
import XSubmitButton from "../../components/XSubmitButton.vue";
import { handleGeneralXhrError, handleValidationXhrError } from "../../helpers";
import TranslationDraftForm from "./TranslationDraftForm.vue";

export default {
    components: {
        XPage,
        XBackButton,
        XSubmitButton,
        TranslationDraftForm,
    },
    computed: {
        batchDisplayName() {
            return this.batch?.display_name || "";
        },
        pageTitle() {
            return this.batch
                ? `Tambah Draft Terjemahan ${this.batchDisplayName}`
                : "Tambah Draft Terjemahan";
        },
    },
    created() {
        this.fetchBatch(this.$route.query.batch_id);
    },
    data() {
        return {
            batch: null,
            errors: null,
            initialFields: {
                batch_id: Number(this.$route.query.batch_id),
            },
            isLoading: false,
        };
    },
    methods: {
        fetchBatch(id) {
            this.isLoading = true;
            const request = axios
                .get(`/api/translation-upload-batches/${id}`, {
                    params: {
                        without_global_scopes: 1,
                    },
                })
                .then((response) => {
                    this.$set(this, "batch", response.data.data);
                });
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false;
            });
        },
        handleSubmit(fields) {
            this.isLoading = true;
            const request = axios
                .post(`/api/translation-drafts`, fields, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((response) => {
                    this.$notify({
                        type: "success",
                        title: `Berhasil`,
                        text: `${response.data.data.title} added!`,
                    });
                    this.$router.back();
                });
            return handleValidationXhrError(request, (errors) => {
                this.errors = errors;
            }).finally(() => {
                this.isLoading = false;
            });
        },
    },
};
</script>
